import {JsonClassType, JsonProperty, ObjectMapper} from "@outfoxx/jackson-js";
import {JsonClassTypeOptions, JsonParserContext} from "@outfoxx/jackson-js/dist/@types";
import {SubscribeKey} from "modules/subscribe/share-app/api/entity/SubscribeKey";

export class SubscribeInfo {
    @JsonProperty()
    readonly id: string;
    @JsonProperty()
    emailsCount: number;
    @JsonProperty()
    telegramsCount: number;
    @JsonProperty()
    readonly previewText: string|null;
    @JsonProperty()
    readonly moduleTitle: string|null;
    @JsonProperty()
    readonly entityTitle: string|null;
    @JsonProperty()
    @JsonClassType(<JsonClassTypeOptions> { type: () => [SubscribeKey] })
    readonly subscribeKey: SubscribeKey;


    public static createByObj(object: object | null): SubscribeInfo {
        if (!object) {
            throw new Error();
        }

        const objectMapper = new ObjectMapper();
        return objectMapper.parse<SubscribeInfo>(JSON.stringify(object), { mainCreator: () => [SubscribeInfo] } as JsonParserContext);
    }
}
